import React, { Component } from "react";
import {
    FormGroup, InputGroup, TextArea, Spinner, Button
} from "@blueprintjs/core";
import { MultiSelect } from "@blueprintjs/select";
import dayjs from "dayjs";

const TRAINING_TYPES = [
    { id: "tehnic", name: "Tehnic" },
    { id: "tactic", name: "Tactic" },
    { id: "fizic", name: "Fizic" },
    { id: "recuperare", name: "Recuperare" },
];

export default class TrainingInfoGeneral extends Component {
    handleFieldChange = (field, value) => {
        this.props.onChange({ [field]: value });
    };

    handleTrainingTypeChange = (item) => {
        const current = (this.props.training.training_type || "").split(",");
        const exists = current.includes(item.id);
        const updated = exists
            ? current.filter(id => id !== item.id)
            : [...current, item.id];
        this.props.onChange({ training_type: updated.join(",") });
    };

    render() {
        const t = this.props.training;
        if (!t) return <Spinner />;

        const selectedItems = (t.training_type || "").split(",")
            .map(id => TRAINING_TYPES.find(t => t.id === id))
            .filter(Boolean);

        return (
            <div className="training-info-general event-wrapper">
                <div className='training-header'>
                    <FormGroup label="Antrenament">
                        <InputGroup
                            className="fm-input"
                            placeholder="A-1"
                            value={t.training_name || ""}
                            onChange={(e) => this.handleFieldChange("training_name", e.target.value)}
                        />
                    </FormGroup>

                    <div className="row-group">
                        <FormGroup label="Data">
                            <div className="date-wrapper">
                                <InputGroup
                                    type="date"
                                    value={t.event_date || dayjs().format("YYYY-MM-DD")}
                                    onChange={(e) => this.handleFieldChange("event_date", e.target.value)}
                                    style={{ width: "100%" }}
                                />
                                <img src="/icons/calendar-white.png" className="calendar-icon" />
                            </div>
                        </FormGroup>

                        <FormGroup label="Ora">
                            <InputGroup
                                type="time"
                                className="bp5-input"
                                step="900"
                                value={t.event_time || "17:00"}
                                onChange={(e) => this.handleFieldChange("event_time", e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup label="Durată (minute)">
                            <InputGroup
                                className="fm-input"
                                placeholder="Ex: 90"
                                type="number"
                                min={0}
                                max={199}
                                value={t.training_duration || 90}
                                onChange={(e) => this.handleFieldChange("training_duration", parseInt(e.target.value) || 0)}
                            />
                        </FormGroup>
                    </div>

                    <div className="row-group two-cols">
                        <FormGroup label="Locație">
                            <InputGroup
                                className="fm-input"
                                placeholder="ex: teren mare"
                                value={t.location || ""}
                                onChange={(e) => this.handleFieldChange("location", e.target.value)}
                            />
                        </FormGroup>

                        <div className='fm-multiselect'>
                            <FormGroup label="Tip antrenament">
                                <MultiSelect
                                    items={TRAINING_TYPES}
                                    selectedItems={selectedItems}
                                    tagRenderer={(item) => item?.name}

                                    itemRenderer={(item, { handleClick, modifiers }) => (
                                        <Button key={item.id}
                                            text={item.name}
                                            active={modifiers.active}
                                            onClick={handleClick}
                                            minimal fill />
                                    )}

                                    // itemRenderer={(item, { handleClick, modifiers }) => (
                                    //     <div key={item.id} onClick={handleClick} className={`bp5-menu-item ${modifiers.active ? "bp5-active" : ""}`}>{item.name}</div>
                                    // )}
                                    onItemSelect={this.handleTrainingTypeChange}
                                    placeholder="Selectează..."
                                    fill
                                    popoverProps={{ minimal: true, matchTargetWidth: true, usePortal: false }}
                                />
                            </FormGroup>
                        </div>
                    </div>

                    <FormGroup label="Descriere / Notițe">
                        <TextArea
                            growVertically
                            fill
                            value={t.description || ""}
                            onChange={(e) => this.handleFieldChange("description", e.target.value)}
                        />
                    </FormGroup>
                </div>
            </div>
        );
    }
}
